(() => {
  const root=document.querySelector('.om-home');
  const control=root?.querySelector('[data-om-view-switch]');
  const grid=root?.querySelector('[data-om-grid]');
  if(!root||!control||!grid)return;
  const buttons=[...control.querySelectorAll('[data-om-view]')];
  const clear=()=>grid.querySelectorAll('.om-wall-revealed').forEach(card=>card.classList.remove('om-wall-revealed'));
  const sizeCards=()=>{
    const columns=matchMedia('(max-width:899px)').matches?2:root.classList.contains('om-photo-wall')?3:4;
    let filled=0,regular=0;
    for(const card of grid.children){
      const wide=card.dataset.landscape==='true'&&regular>=4&&columns-filled%columns>=2;
      card.classList.toggle('om-card-wide',wide);filled+=wide?2:1;regular=wide?0:regular+1;
    }
  };
  const setView=view=>{
    const wall=view==='wall';
    root.classList.toggle('om-photo-wall',wall);
    buttons.forEach(button=>button.setAttribute('aria-pressed',String((button.dataset.omView==='wall')===wall)));
    clear();
    sizeCards();
  };
  control.hidden=false;
  control.addEventListener('click',event=>{const button=event.target.closest('[data-om-view]');if(button)setView(button.dataset.omView);});
  grid.addEventListener('click',event=>{
    const image=event.target.closest('.om-card-image');
    if(!image||!root.classList.contains('om-photo-wall')||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||event.detail===0)return;
    const touch=event.pointerType==='touch'||event.pointerType==='pen'||matchMedia('(hover:none)').matches;
    if(!touch)return;
    const card=image.closest('.om-card');
    if(card.classList.contains('om-wall-revealed'))return;
    event.preventDefault();clear();card.classList.add('om-wall-revealed');
  });
  document.addEventListener('click',event=>{if(!event.target.closest('[data-om-grid]'))clear();});
  root.addEventListener('keydown',event=>{if(event.key==='Escape')clear();});
  new MutationObserver(sizeCards).observe(grid,{childList:true});
  matchMedia('(max-width:899px)').addEventListener('change',sizeCards);
  setView(new URL(location.href).searchParams.get('orbit_view')==='wall'?'wall':'magazine');
})();
